let id = 0;

function newId() : number {
  id += 1;
  return id;
}

export default newId;
